module.exports = __webpack_public_path__ + "static/media/22.10f48234.png";